import { create } from 'zustand'

type VacationCalendarState = {
  date: Date
  setDate: (date: Date) => void
  showWeekNumbers: boolean
  setShowWeekNumbers: (show: boolean) => void
  showNeighboringMonths: boolean
  setShowNeighboringMonths: (show: boolean) => void
  showHolidays: boolean
  setShowHolidays: (show: boolean) => void
  holidayCountry: string
  setHolidayCountry: (country: string) => void
  selectedTypes: string[]
  setSelectedTypes: (typeIds: string[]) => void
  departmentIds: string[]
  setDepartmentIds: (departmentIds: string[]) => void
  showApprovedAbsence: boolean
  setShowApprovedAbsence: (show: boolean) => void
  showUnapprovedAbsence: boolean
  setShowUnapprovedAbsence: (show: boolean) => void
  showDeniedAbsence: boolean
  setShowDeniedAbsence: (show: boolean) => void
}

const useVacationCalendarStore = create<VacationCalendarState>(set => ({
  date: new Date(),
  setDate: date => {
    set({ date })
  },
  showWeekNumbers: true,
  setShowWeekNumbers: show => {
    set({ showWeekNumbers: show })
  },
  showNeighboringMonths: true,
  setShowNeighboringMonths: show => {
    set({ showNeighboringMonths: show })
  },
  showHolidays: true,
  setShowHolidays: show => {
    set({ showHolidays: show })
  },
  holidayCountry: 'da',
  setHolidayCountry: country => {
    set({ holidayCountry: country })
  },
  selectedTypes: [],
  setSelectedTypes: typeIds => {
    set({ selectedTypes: typeIds })
  },
  departmentIds: [],
  setDepartmentIds: departmentIds => {
    set({ departmentIds })
  },
  showApprovedAbsence: true,
  setShowApprovedAbsence(show) {
    set({ showApprovedAbsence: show })
  },
  showUnapprovedAbsence: true,
  setShowUnapprovedAbsence(show) {
    set({ showUnapprovedAbsence: show })
  },
  showDeniedAbsence: true,
  setShowDeniedAbsence(show) {
    set({ showDeniedAbsence: show })
  },
}))

export default useVacationCalendarStore
